// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetCriteria = () => getDefaultState().criteria;

const updateCriteria = (state, action) => action.criteria;

export default (state = getDefaultState().criteria, action) => {

    const actionTypes = {
        [actions.RESET_PIP_HISTORY_REPORT_CRITERIA]: resetCriteria,
        [actions.UPDATE_PIP_HISTORY_REPORT_CRITERIA]: updateCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pip-history/reducers/criteria.js